export default "__VITE_PUBLIC_ASSET__d26d7d96__"